import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './styles.css';

/* Screens */
// import MainScreen from '../../components/Screens/MainScreen';
// import MusicsScreen from '../../components/Screens/MusicsScreen'; // Microphone 
// import Visualizer from '../../components/Visualizer';
// import MusicExample from '../../components/Screens/MusicExample';
import MusicFFTScreen2 from '../../components/Screens/MusicFFTScreen2';

// Não tá clean

export default class ReturnMusicsNewScreen2 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            screen: 'Main'
        }
    }
    goBackButton() {
        <Link to={'/'}> Voltar </Link>
    }

    /**
     * @Algoritmo de trocar de tela:
     * Criar botôes com os nomes: 'Musicas', 'Microfone' & 'Configurações'.
     * Esses botôes vão executar funções que vão dar um SetState com seus respectivos valores
     * 
     * Verificar o `this.state` e mostrar a tela
     *  
     */

    render() {
        return(
            <div className="back-cover">
                <div className="main">
                    <div className="screen">
                        {/* <img src="http://iphonewrd.com/img/loading.gif" /> */}
                        <div className='ipodmenulist'>

                            <MusicFFTScreen2 /> 

                        </div>
                    </div>
                    <div className="navigator">        
                        <div className="keys">       
                            {/* <!--nav keys--> */}

                            <span className="menu-btn">MENU</span>
                        
                            <img className="fwd" src="https://cdn2.iconfinder.com/data/icons/snipicons/5000/fast-forward-256.png" />
                            
                            <img className="bkd" src="https://cdn2.iconfinder.com/data/icons/snipicons/5000/fast-backward-128.png" />
                            
                            <img className="play-pause" src="https://cdn2.iconfinder.com/data/icons/snipicons/5000/play-128.png" />
                        
                            <div className="play">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

